/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ description: NonNullable<unknown>, value: NonNullable<unknown> }} Top_Alive_Shark_MixInputs */

const fr_top_alive_shark_mix = /** @type {(inputs: Top_Alive_Shark_MixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`La permission ${i?.description} a été ${i?.value}.`)
};

/**

* @param {Top_Alive_Shark_MixInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const top_alive_shark_mix = /** @type {((inputs: Top_Alive_Shark_MixInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Top_Alive_Shark_MixInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_top_alive_shark_mix(inputs)
});